export default "__VITE_ASSET__CrGzNPqI__"